import { Component, OnInit, Input, ViewChild } from '@angular/core'
import {
  GALLERY_CONF,
  GALLERY_IMAGE,
  NgxImageGalleryComponent,
} from 'ngx-image-gallery'
import { environment } from 'src/environments/environment'
import {
  DicomHeaderService,
  DicomTag,
} from 'src/app/core/dicom-header.service'
import { reportHandled } from 'src/app/core/errors/issueTracker'

@Component({
  selector: 'app-image-viewer',
  templateUrl: './image-viewer.component.html',
  styleUrls: ['./image-viewer.component.scss'],
})
export class ImageViewerComponent implements OnInit {
  @ViewChild(NgxImageGalleryComponent) ngxImageGallery: NgxImageGalleryComponent

  dev(): boolean {
    return environment.appUri.includes('ngrok')
  }

  // gallery configuration
  @Input() conf: GALLERY_CONF = {
    imageOffset: '0px',
    showDeleteControl: false,
    showImageTitle: true,
  }

  // gallery images
  @Input() images: GALLERY_IMAGE[]

  /**
   * Optional: the stored `.dcm` key for each image, parallel to `images`. When
   * provided, each thumbnail gets a "DICOM header" control that opens the shared
   * header modal (fetching + parsing that image's raw DICOM on demand).
   */
  @Input() dcmKeys: string[]

  // DICOM header modal state.
  headerModalOpen = false
  headerTags: DicomTag[] | null = null
  headerLoading = false
  headerSubtitle = ''

  constructor(private dicomHeaderService: DicomHeaderService) {}

  ngOnInit(): void {}

  async onViewHeader(dcmKey: string): Promise<void> {
    if (!dcmKey) return
    this.headerSubtitle = dcmKey
    this.headerTags = null
    this.headerLoading = true
    this.headerModalOpen = true
    try {
      this.headerTags = await this.dicomHeaderService.fetchTags(dcmKey)
    } catch (e) {
      console.error('failed to load DICOM header', e)
      reportHandled(e, 'load a DICOM header')
      this.headerTags = []
    } finally {
      this.headerLoading = false
    }
  }

  openGallery(index = 0) {
    this.ngxImageGallery.open(index)
  }

  // close gallery
  closeGallery() {
    this.ngxImageGallery.close()
  }

  // set new active(visible) image in gallery
  newImage(index = 0) {
    this.ngxImageGallery.setActiveImage(index)
  }

  // next image in gallery
  nextImage(index = 0) {
    this.ngxImageGallery.next()
  }

  // prev image in gallery
  prevImage(index = 0) {
    this.ngxImageGallery.prev()
  }

  /** *********************************************** */

  // EVENTS
  // callback on gallery opened
  galleryOpened(index) {}

  // callback on gallery closed
  galleryClosed() {}

  // callback on gallery image clicked
  galleryImageClicked(index) {}

  // callback on gallery image changed
  galleryImageChanged(index) {}

  // callback on user clicked delete button
  deleteImage(index) {}
}
